import HelpText from './HelpText';

export interface SectionHeaderBarProps {
    title: string;
    children?: React.ReactNode;
    showHelp?: boolean;
}

export const SectionHeaderBar: React.FC<SectionHeaderBarProps> = ({ title, children = null, showHelp = true }) => {
    return (
        <div
            className='section-header-bar'
            role='banner'
        >
            <h1>{title}</h1>
            <div className='primary-actions'>
                {children && children}
                {showHelp && <HelpText />}
            </div>
        </div>
    );
};
